/* eslint @typescript-eslint/no-explicit-any: 0 */
import dayjs, { Dayjs } from 'dayjs';
import { z } from 'zod';

export const IdSchema = z.object({
  id: z.uuid(),
});
export const IdOptionalSchema = z.object({
  id: z.uuid().optional(),
});
export const IdStringSchema = z.object({
  id: z.string(),
});
export const GeoLocationSchema = z.object({
  lat: z.string().nullish(),
  lng: z.string().nullish(),
});

export const NameSchema = z.object({
  name: z.string(),
});

export const NameValueSchema = z.object({
  name: z.string(),
  value: z.string(),
});

export const NameCodeSchema = z.object({
  name: z.string(),
  code: z.string(),
});

export const IdNameSchema = z.object({
  id: z.uuid(),
  name: z.string(),
});

export const LabelValueSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const DayJsSchema = z.custom<Dayjs>(
  (val) => val instanceof dayjs,
  'Invalid Day.js type' // TODO: Translate - It's rare this will be returned or explicitly returned. It just prevents having to type-cast
);

export const StatusTypesEnum = z.enum(['active', 'inactive']);

export const EmptyResponseSchema = z.string().length(0).or(z.undefined());

export const TreeBaseSchema = z.object({
  key: z.string(),
  title: z.string(),
  value: z.string(),
});

// According to Zod docs, this is how you handle a recursive type and schema
export type TreeModel = z.infer<typeof TreeBaseSchema> & {
  children?: TreeModel[];
};

export const TreeSchema: z.ZodType<TreeModel> = TreeBaseSchema.extend({
  children: z.lazy(() => TreeSchema.array()).optional(),
});

export const HttpStatusCodesEnum = z.enum([
  '400',
  '401',
  '403',
  '404',
  '405',
  '409',
  '500',
  '502',
  '503',
  '504',
]);

export const WeekdaysEnum = z.enum([
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]);

export type IdModel = z.infer<typeof IdSchema>;
export type IdStringModel = z.infer<typeof IdStringSchema>;
export type IdNameModel = z.infer<typeof IdNameSchema>;
export type GeoLocationModel = z.infer<typeof GeoLocationSchema>;
export type NameModel = z.infer<typeof NameSchema>;
export type NameValueModel = z.infer<typeof NameValueSchema>;
export type LabelValueModel = z.infer<typeof LabelValueSchema>;
export type HttpStatusCode = z.infer<typeof HttpStatusCodesEnum>;
export type NameCodeModel = z.infer<typeof NameCodeSchema>;
